import { render } from "./HowToSignUp.vue?vue&type=template&id=36d2cbda"
import script from "./HowToSignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToSignUp.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/static-pages/HowToSignUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36d2cbda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36d2cbda', __exports__)) {
    api.reload('36d2cbda', __exports__)
  }
  
  module.hot.accept("./HowToSignUp.vue?vue&type=template&id=36d2cbda", () => {
    api.rerender('36d2cbda', render)
  })

}


export default __exports__